import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-environmentalstudies',
  templateUrl: './environmentalstudies.component.html',
  styleUrls: ['./environmentalstudies.component.css']
})
export class EnvironmentalstudiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
